import { bl_rvm_cfp_engagement_member_RowClass } from '../../../dbschema/bl_rvm_cfp_engagement_member.model';
import { BaseContainerModel } from '../../base-container.model';

export class CfpEngagementMemberContainerModel extends BaseContainerModel {
  bl_rvm_cfp_engagement_member: bl_rvm_cfp_engagement_member_RowClass = new bl_rvm_cfp_engagement_member_RowClass();
}
